export default "__VITE_ASSET__Mc4a3deF__"